//#region frontend/islands/carousel-nav.js
var CarouselNav = class extends HTMLElement {
	connectedCallback() {
		this._track = document.getElementById(this.dataset.target);
		this._prev = this.querySelector("[data-prev]");
		this._next = this.querySelector("[data-next]");
		this._prev.addEventListener("click", () => this._scroll(-1));
		this._next.addEventListener("click", () => this._scroll(1));
		this._track.addEventListener("scroll", () => this._updateButtons(), { passive: true });
		this._updateButtons();
	}
	_scroll(dir) {
		if (!this._track) return;
		const card = this._track.querySelector(".multi-card-banner-card");
		if (!card) return;
		const gap = parseFloat(getComputedStyle(this._track).columnGap) || 0;
		this._track.scrollBy({
			left: dir * (card.offsetWidth + gap),
			behavior: "smooth"
		});
	}
	_updateButtons() {
		const { scrollLeft, scrollWidth, clientWidth } = this._track;
		this._prev.disabled = scrollLeft <= 0;
		this._next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
	}
};
customElements.define("carousel-nav", CarouselNav);
//#endregion
